import {
  CheckIcon,
  CloseIcon,
  RemoveIcon,
  ShareIcon,
  TrashIcon,
  UploadIcon,
} from "./action-icons";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronUpIcon,
} from "./arrow-icons";

import { CalenderIcon } from "./calender-icon";
import { AddToCartIcon, CartIcon, FilterIcon, HeartIcon } from "./cart";
import { CloseEyeIcon, OpenEyeIcon } from "./password-icons";
import { MinusIcon, PlusIcon } from "./quantity-icons";
import { ScrollIcon } from "./scroll-icon";
import { SearchIcon } from "./search";
import {
  FacebookIcon,
  InstagramColoredIcon,
  InstagramIcon,
  LinkedinIcon,
  PinterestIcon,
  SnapchatIcon,
  XIcon,
  YoutubeIcon,
} from "./social-icons";
import { HeartFilledIcon, HeartSolidIcon, UserIcon } from "./user-icons";

// Arrow Icons
export const ChevronDown = ChevronDownIcon;
export const ChevronUp = ChevronUpIcon;
export const ChevronRight = ChevronRightIcon;
export const ArrowRight = ArrowRightIcon;
export const ArrowLeft = ArrowLeftIcon;

// Action Icons
export const Upload = UploadIcon;
export const Remove = RemoveIcon;
export const Close = CloseIcon;
export const Share = ShareIcon;
export const Check = CheckIcon;
export const Trash = TrashIcon;

// Password Icons
export const CloseEye = CloseEyeIcon;
export const OpenEye = OpenEyeIcon;

// User Icons
export const User = UserIcon;

// Social Icons
export const Instagram = InstagramIcon;
export const InstagramColored = InstagramColoredIcon;
export const Facebook = FacebookIcon;
export const Twitter = XIcon;
export const Youtube = YoutubeIcon;
export const LinkedIn = LinkedinIcon;
export const Pinterest = PinterestIcon;
export const Snapchat = SnapchatIcon;

export const socialIcons = {
  facebook: Facebook,
  instagram: Instagram,
  twitter: Twitter,
  youtube: Youtube,
  linkedIn: LinkedIn,
  snapchat: Snapchat,
  pinterest: Pinterest,
};

// General Icons
export const Search = SearchIcon;
export const Cart = CartIcon;
export const AddToCart = AddToCartIcon;
export const Scroll = ScrollIcon;
export const Calendar = CalenderIcon;
export const Heart = HeartIcon;
export const HeartSolid = HeartSolidIcon;
export const HeartFilled = HeartFilledIcon;
export const Filter = FilterIcon;
// Quantity Icons
export const Minus = MinusIcon;
export const Plus = PlusIcon;
